import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

export const savedCardService = {
  getSavedCards: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.savedCards.getSavedCards,
      payload,
      headers,
      hasErrorHandler,
    }),
  updateSavedCard: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.savedCards.updateSavedCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  deleteSavedCard: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.savedCards.deleteSavedCard,
      payload,
      headers,
      hasErrorHandler,
    }),
  sendSaveCardOTP: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.savedCards.sendSaveCardOTP,
      payload,
      headers,
      hasErrorHandler,
    }),
  saveCard: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.account.savedCards.saveCard,
      payload,
      headers,
      hasErrorHandler,
    }),
};
